<script lang="ts">
  interface FilterEntry {
    position: number;
    /*                                                                                                    */
    serialized: string;
  }

  interface Props {
    containsOnlyRelevantFilters: boolean;
    visibleFilters: FilterEntry[];
    hiddenFilters: FilterEntry[];
  }

  const { containsOnlyRelevantFilters, visibleFilters, hiddenFilters }: Props = $props();
</script>

{#snippet filterPlaceholder(entry: FilterEntry)}
  <div
    class="ts_heureka_svelteFilterForm"
    style="display: none"
    data-position={entry.position}
    data-serialized={entry.serialized}
  ></div>
{/snippet}

<div class="heureka_denseMode">
  <dl class="heureka_denseList">
    {#each visibleFilters as entry (entry.position)}
      {@render filterPlaceholder(entry)}
    {/each}
  </dl>
</div>
<div
  class="heureka_expandedMode heureka_expandedMode--ocComponents"
  {...containsOnlyRelevantFilters ? { hidden: "" } : {}}
>
  <oc-expander-v1
    id="heureka_filterlistExpanderDesktop"
    class="heureka_filterlistExpander heureka_filterlistExpander--desktop"
    variant="row"
    hide-fade=""
    cutoff-height="0"
    oc-aria-label="Weitere Filter"
  >
    <dl class="heureka_expandedList">
      {#each hiddenFilters as entry (entry.position)}
        {@render filterPlaceholder(entry)}
      {/each}
    </dl>
    <span class="heureka_expander-text" slot="show-more-text">Mehr Filter anzeigen</span>
    <div class="heureka_expandedMode__divider"></div>
    <span slot="show-less-text">Weniger Filter anzeigen</span>
  </oc-expander-v1>
</div>
